import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullCalendar = _resolveComponent("FullCalendar", true)!

  return (_openBlock(), _createBlock(_component_FullCalendar, {
    class: "calendar-wrapper h-100",
    options: _ctx.calendarOptions
  }, null, 8 /* PROPS */, ["options"]))
}